import React from "react";

class StripeScreen extends React.Component {
  style = {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    filterIconWrapper: {
      margin: "0px 20px",
      backgroundColor: "#00b4d2",
      borderRadius: "100%",
      padding: "15px",
      cursor: "pointer"
    },
    filterIcon: {
      width: "30px",
      height: "30px"
    },
    box: {
      width: "1200px"
    }
  };
  state = {
    qlist: []
  };

  getp = key => {
    if (window.location.search)
      return window.location.search
        .substr(1)
        .split("&")
        .filter(str => str.split("=")[0] === key)[0]
        .split("=")[1];
  };
  componentDidMount() {
    if (this.getp("code")) {
      localStorage.setItem("authorization_code", this.getp("code"));
      setTimeout(() => {
        window.close();
      }, 5000);
    }
  }
  render() {
    return (
      <div style={this.style.wrapper}>
        <br />
        <h1>
          <br />
          Stripe Authorization Code Recieved Continue on previous page. <br />
          You May Close this window.
          <br />
          The Page will autoclose in 5s
        </h1>
      </div>
    );
  }
}

export default StripeScreen;
